import _extends from "babel-runtime/helpers/extends";
import { initialState } from "./reducer";

var localState = function localState(state) {
  return state && state.sre && state.sre.playsound || initialState;
};

var selectors = {
  getPlaySoundSessionId: function getPlaySoundSessionId(state) {
    return localState(state).sessionId;
  },
  getPlaySoundSessionData: function getPlaySoundSessionData(state) {
    return localState(state).sessionData;
  },
  getPlaySoundSessionSoundObj: function getPlaySoundSessionSoundObj(state) {
    return localState(state).soundObj;
  },
  getPlaySoundSessionSoundLog: function getPlaySoundSessionSoundLog(state) {
    return localState(state).soundLog;
  },
  getPlaySoundSessionIsPlaying: function getPlaySoundSessionIsPlaying(state) {
    return localState(state).playing === true;
  },
  getPlaySoundSessionStartTimeMS: function getPlaySoundSessionStartTimeMS(state) {
    return localState(state).sessionData && localState(state).sessionData.getStartTimeMS();
  },
  getPlaySoundSessionTotalTimeMS: function getPlaySoundSessionTotalTimeMS(state) {
    return localState(state).sessionData && localState(state).sessionData.getTotalTimeMS();
  },
  getPlaySoundSessionCurrentTimeMS: function getPlaySoundSessionCurrentTimeMS(state) {
    return localState(state).sessionData && localState(state).sessionData.getCurrentTimeMS();
  }
};

export default _extends({}, selectors, {
  getPlaySoundState: localState
});